import { useState } from 'react'

export const useSnackBar = () => {
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [snackBarMessage, setSnackBarMessage] = useState('')

  const snackFunc = (showText: string, goBack: boolean, error?: boolean) => {
    setSnackBarMessage(showText)
    setOpenSnackBar(true)
    !error &&
      setTimeout(
        () => {
          setOpenSnackBar(false)
        },
        goBack ? 2500 : 5000
      )
  }

  const close = () => {
    setOpenSnackBar(false)
  }

  return {
    openSnackBar,
    snackBarMessage,
    snackFunc,
    close,
  }
}
